import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { ChevronUp } from "lucide-react";
 * // Use <ChevronUp /> instead
 */
export const ChervonUpIcon = createSVGWrapper(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M6.293 14.707a1 1 0 0 0 1.414 0L12 10.414l4.293 4.293a1 1 0 0 0 1.414-1.414l-5-5a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 0 1.414Z"
    clipRule="evenodd"
  />
);
